import * as React from "react";
import * as Chakra from "@chakra-ui/react";
import { ListItemElement } from "../../../../duck";

interface ListItemProps {
  attributes: any;
  children: React.ReactNode;
  element: ListItemElement;
  elementProps: Record<string, any>;
}

const ListItem: React.FC<ListItemProps> = ({
  children,
  element,
  attributes,
  elementProps
}) => {
  const { marks } = element;
  const markStyles: Chakra.ListItemProps = marks
    ? {
        fontWeight: marks.bold ? "bold" : "normal",
        textDecoration: marks.underline ? "underline" : "none",
        fontStyle: marks.italic ? "italic" : "normal"
      }
    : {};

  return (
    <Chakra.ListItem {...attributes} {...elementProps} {...markStyles}>
      {children}
    </Chakra.ListItem>
  );
};

export default ListItem;
